export function RaktarPrint({ id, job }) {
  return (
    <iframe id={"aprint"} src={"/json/delivery/print/raktar/" + id + "?job=" + encodeURIComponent(job)} style={{ display: 'none' }} title="Összekészítési lista nyomtatás" />
  );
}

export function RaktarPrintAll({ ids, job }) {
  console.log("RaktarPrintAll", ids, job);
  return (
    <iframe id={"aprint"} src={"/json/delivery/print/raktar_all?ids=" + ids.join(',') + "&job=" + encodeURIComponent(job)} style={{ display: 'none' }} title="Összekészítési lista nyomtatás" />
  );
}

export function printRaktar(id, job) {
  window.open("/json/delivery/print/raktar/" + id + "?job=" + encodeURIComponent(job), 'delivery_printer');
}